import { render, staticRenderFns } from "./VastuualueBox.vue?vue&type=template&id=da1019de&scoped=true"
import script from "./VastuualueBox.vue?vue&type=script&lang=js"
export * from "./VastuualueBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1019de",
  null
  
)

export default component.exports